export default "__VITE_ASSET__DxvJYrUg__"